import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private readonly config = (window as any)['__env'] || {};

  get googleApiKey(): string {
    return this.config.googleMapsApiKey || '';
  }
}
